module.exports = __webpack_public_path__ + "img/bannerBG2.200e8ece.png";